<template>
    <FciDialog title="Web View" :width="1000" v-model="show">
        <div class="WebViewEditor pa-3">
            <v-form ref="form" v-model="formValid" @submit="submit">
                <v-radio-group :label="this.$f.tc('type')" row class="mt-0" v-model="type">
                    <v-radio
                        label="Web URL"
                        :value="WebViewType.SITE"
                    ></v-radio>
                    <v-radio
                        label="Web Form"
                        :value="WebViewType.CUSTOM"
                    ></v-radio>
                </v-radio-group>
                <v-text-field
                    outlined
                    dense
                    :rules="formRules.required"
                    :label="this.$f.tc('name')"
                    v-model="name"
                ></v-text-field>
                <v-text-field
                    outlined
                    dense
                    :rules="formRules.required"
                    label="URL"
                    v-model="url"
                    v-if="type === WebViewType.SITE"
                ></v-text-field>
                <template v-else>
                    <v-select
                        outlined
                        dense
                        v-model="call_back_step"
                        clearable
                        label="Go to Step after Submit"
                        :items="stepList"
                        item-value="code"
                        item-text="name"
                    ></v-select>
                    <table>
                        <tr>
                            <td>{{ $f.tc('name') }}</td>
                            <td>{{ $f.tc('variable') }}</td>
                            <td>{{ $f.tc('type') }}</td>
                            <td>
                                {{ $f.tc('data') }}
                                <v-tooltip top>
                                    <template v-slot:activator="{on}">
                                        <v-icon v-on="on" small>mdi-help-circle</v-icon>
                                    </template>
                                    <div>Data format: value|label;value_2|label_2;</div>
                                </v-tooltip>
                            </td>
                            <td>{{ $f.tc('require') }}</td>
                            <td></td>
                        </tr>
                        <tr v-for="(control, i) in controls" :key="i">
                            <td>
                                <v-text-field
                                    outlined
                                    dense
                                    :rules="formRules.required"
                                    v-model="control.field_name"
                                ></v-text-field>
                            </td>
                            <td>
                                <!-- <v-tooltip top>
                                    <template v-slot:activator="{on}">
                                        <v-icon v-on="on" small>mdi-help-circle</v-icon>
                                        <v-select
                                            v-on="on"
                                            outlined
                                            dense
                                            :rules="formRules.required"
                                            v-model="control.field_data"
                                            :items="variableList"
                                            item-text="name"
                                            item-value="name"
                                            ></v-select>
                                    </template>
                                    <div>{{control.field_data}}</div>
                                </v-tooltip> -->
                                <v-select
                                    outlined
                                    dense
                                    :rules="formRules.required"
                                    v-model="control.field_data"
                                    :items="variableList"
                                    item-text="name"
                                    item-value="name"
                                    @change="handleSelectChange(control)"
                                    @mouseover.native="setVariableNameStatus(i, true)" @mouseleave.native="setVariableNameStatus(i, false)"
                                ></v-select>
                                <div class="info" v-if="showFullVariableName[i]">
                                <p>{{ control.field_data }}</p>
                                </div><!-- End Info -->
                            </td>
                            <td v-if="control.field_type !== 'text' && control.field_type !== 'dropdown' && control.field_type !== 'multi_select'" class="center-cell">
                                <v-text-field
                                    outlined
                                    dense
                                    :rules="formRules.required"
                                    :model-value="control.field_type"
                                    :value="control.field_type"
                                    readonly="true"
                                ></v-text-field>
                                <!-- <p>{{ control.field_type }}</p> -->
                            </td>
                            <td v-else>
                                <v-select
                                    outlined
                                    dense
                                    :rules="formRules.required"
                                    v-model="control.field_type"
                                    :items="typeList"
                                ></v-select>
                            </td>
                            <td>
                                <v-text-field
                                    outlined
                                    dense
                                    :rules="formRules.required"
                                    v-model="control.data"
                                    v-if="control.field_type === 'dropdown' || control.field_type === 'multi_select'"
                                ></v-text-field>
                                <v-text-field
                                    outlined
                                    dense
                                    v-model="control.data"
                                    v-else
                                    disabled
                                ></v-text-field>
                            </td>
                            <td class="pl-3">
                                <v-checkbox
                                    v-model="control.required"
                                    style="margin: 0"
                                ></v-checkbox>
                            </td>
                            <td>
                                <v-btn icon style="margin-bottom: 20px" @click="deleteControl(i)">
                                    <v-icon>mdi-delete-outline</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </table>
                    <div class="mt-3">
                        <v-btn color="primary" @click="addControl" style="margin-right: 100px">
                            {{ $f.tc('add') }}
                        </v-btn>
                        <v-btn outlined @click="addScenarioVariable">
                            <v-icon color="primary" small class="mr-1">mdi-plus-circle</v-icon>
                            {{ $f.tc('variable') }}
                        </v-btn>
                    </div>
                </template>
                <v-layout>
                    <v-flex></v-flex>
                    <v-btn color="primary" type="submit">{{ $f.tc('save') }}</v-btn>
                </v-layout>
            </v-form>
        </div>
    </FciDialog>
</template>

<script>
import DialogEditorMixin from '@/modules/fptai/mixins/DialogEditorMixin'
import { mapState } from 'vuex'
import { WebViewType } from '@/utils/const'
import { AppEventBusType } from '@/eventbus/app.eventbus'

export default {
    name: 'WebViewEditor',
    mixins: [DialogEditorMixin],
    data () {
        return {
            self: this,
            WebViewType,
            type: '',
            name: '',
            url: '',
            controls: [],
            showFullVariableName: [],
            typeList: [
                {
                    text: 'Text',
                    value: 'text'
                },
                {
                    text: 'Dropdown',
                    value: 'dropdown'
                },
                {
                    text: 'Multi-Select',
                    value: 'multi_select'
                },
                {
                    text: 'Datetime',
                    value: 'datetime'
                }
            ],
            call_back_step: ''
        }
    },
    computed: {
        ...mapState({
            stepList: state => state.scenario.stepList,
            variableList: state => state.scenario.variableList
        })
    },
    methods: {
        setVariableNameStatus (index, status) {
            this.$set(this.showFullVariableName, index, status)
        },
        handleSelectChange (control) {
            // Lấy thông tin của mục được chọn
            if (control.field_data !== '') {
                for (let i = 0; i < this.variableList.length; i++) {
                    if (this.variableList[i].name === control.field_data) {
                        control.field_type = this.variableList[i].memory_type_id
                        break
                    }
                }
            }
        },
        onOpen () {
            if (this.item) {
                this.name = this.item.name
                this.type = this.item.config.type
                this.url = this.item.config.url || ''
                if (this.item.config.controls) {
                    this.controls = this.$ut.cloneObject(this.item.config.controls)
                } else {
                    this.controls = []
                    this.addControl()
                }
                if (this.type === WebViewType.CUSTOM) {
                    this.call_back_step = this.item.config.call_back_step
                } else {
                    this.call_back_step = ''
                }
                this.showFullVariableName = Array(this.controls.length).fill(false)
            } else {
                this.type = WebViewType.SITE
                this.name = ''
                this.url = ''
                this.controls = []
                if (this.$refs.form) {
                    this.$refs.form.resetValidation()
                }
            }
        },
        addControl () {
            this.controls.push({
                field_name: '',
                field_type: '',
                field_data: '',
                data: '',
                required: ''
            })
        },
        deleteControl (index) {
            this.controls.splice(index, 1)
        },
        submitValidForm () {
            this.close()
            if (this.type === WebViewType.SITE) {
                this.promise.resolve({
                    name: this.name,
                    config: {
                        type: WebViewType.SITE,
                        url: this.url
                    }
                })
            } else {
                this.promise.resolve({
                    name: this.name,
                    config: {
                        type: WebViewType.CUSTOM,
                        controls: this.controls,
                        call_back_step: this.call_back_step
                    }
                })
            }
        },
        addScenarioVariable () {
            this.$appService.useEventBus(AppEventBusType.OPEN_VARIABLE_EDITOR, null).then(item => {
                this.$store.dispatch(this.$at.scenario.CREATE_VARIABLE, {
                    name: item.name,
                    entity: item.entity,
                    memory_type_id: item.memory_type_id,
                    is_scenario_scope: false
                }).then(newVariable => {
                    if (this.type !== WebViewType.CUSTOM) {
                        return
                    }
                    if (this.controls.length < 1) {
                        this.addControl()
                    }
                    this.controls[this.controls.length - 1].field_data = newVariable.name
                })
            })
        }
    }
}
</script>

<style scoped lang="scss">
.WebViewEditor {
    min-height: 500px;
}

table {
    width: 100%;

    tr:first-child td {
        padding-left: 5px;
    }

    tr td {
        &:nth-child(1) {
            width: 150px;
        }

        &:nth-child(2) {
            width: 150px;
        }

        &:nth-child(3) {
            width: 150px;
        }
    }
}
.center-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: medium;
    height: 100%; /* Đảm bảo chiều cao của cell được căn giữa */
}

.info{
  background: rgba(0, 0, 0, 0.7) !important;
  color: #fff !important;
  margin-top: -20px;
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 5px;
  position: absolute;
  z-index: 500;
  p{
    color: #ffffff;
    font-size: 15px;
  }
}
</style>
